import Vue from "vue";
import CourseNameGenerator from "./components/CourseNameGenerator.vue";
import Vuex from "vuex";
import store from './store/index';

Vue.use( Vuex );

Vue.mixin({
    methods: {
        m_cloud_url(path = '') {
            return window.m_cloud_url + path;
        },

        step1_url() {
            return window.step1_url;
        }
    },
});

axios.defaults.headers.common = {
    'X-Requested-With': 'XMLHttpRequest',
    'CONTENT_TYPE': 'application/json',
    'ACCEPT': 'application/json',
    'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
};

new Vue({
    el: '#courseNameGenerator',
    components: {
        CourseNameGenerator
    },
    store
});
